//TODO: Delete this one and replace it for the new one in @/app/shared/store/modules/...filterRequestObject

const initialState = () => ({
  asyncProductPool: [],
  selectedOptions: {store_filters: [], product_filters: []},
  isSelectedFilters: {store_filters: false, product_filters: false},
  activeFilterObjectInstance: {
    store_filters: {
      retail_id: [],
      store_id: [],
      comuna: [],
      region_id: [],
      store_type_id: [],
      mall_id: [],
      distribution_type_id: [],
      retail_type_id: [],
      store_is_active: []
    },
    product_filters: {
      product_category_hlev1_id: [],
      product_map_id: [],
      product_id: [],
      product_category_hlev2_id: [],
      product_category_hlev3_id: [],
      product_category_hlev4_id: [],
      color_id: [],
      brand_id: [],
      attr_1_id: [],
      attr_2_id: [],
      attr_3_id: [],
      attr_4_id: [],
      attr_5_id: [],
      attr_6_id: [],
      attr_7_id: [],
      attr_8_id: [],
      obsolete: []
    }
  }
})

const state = initialState()

const mutations = {
  commit_filterRequestObject_isSelectedFilters (state, payload) {
    state.isSelectedFilters[payload['filterType']] = payload['value']
  },
  commit_filterRequestObject_activeFilterObjectInstance (state, activeFilterObjectInstance) {
    state.activeFilterObjectInstance = activeFilterObjectInstance
  },
  commit_filterRequestObject_selectedOptions (state, payload) {
    state.selectedOptions[payload['filterType']] = payload['filtersRenderObject']
  },
  commit_filterPane_resetState (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  commit_async_product_pool (state, payload) {
    state.asyncProductPool = payload

  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filterRequestObject.js